export default "__VITE_ASSET__DBKAM6cQ__"